import React, { useEffect, useState } from 'react'
import { Modal, Button, TimePicker, DatePicker } from 'antd'
import TextArea from 'antd/lib/input/TextArea';
import './style.css'
import moment from 'moment';
import { rejectTimeSheet } from "../../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { LoadingOutlined } from '@ant-design/icons';

const CorrectionModal = (props) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [StartValue, setStartValue] = useState("");
    const [EndValue, setEndValue] = useState("");
    const [correctionReason, setCorrectionReason] = useState("");

    const rejectTimeSuccess = useSelector(state => state.rejectTimeSheetReducer.success)
    const loading = useSelector(state => state.rejectTimeSheetReducer.loading)


    useEffect(() => {
        setStartValue(props.startTime)
        setEndValue(props.endTime)
    }, [props]);

    const dispatch = useDispatch();

    const handleOk = () => {
        props.close(false);

        dispatch(
            rejectTimeSheet({
                Date: props.date,
                TimeSheetId: props.id,
                StartTime: StartValue.toUpperCase(),
                EndTime: EndValue.toUpperCase(),
                Reason: correctionReason,
                Status: "Pending",
            })
        )
    };

    const handleclose = () => {
        setIsModalVisible(false);
        props.close(false);
    }

    useEffect(() => {
        setIsModalVisible(props.open)
    }, [props])

    useEffect(() => {
        if (rejectTimeSuccess) {
            setIsModalVisible(false);
        }
    }, [rejectTimeSuccess])




    return (
        <div>
            <Modal className='correction-modal' centered visible={isModalVisible} onOk={handleOk} width={660} onCancel={handleclose}
                footer={[
                    <button className='send-for-correction-btn' onClick={handleOk}>
                        {loading ? <LoadingOutlined /> : 'Send Request'}
                    </button>
                ]}
            >
                <div className='drawer-time-container'>
                    <div className='start-time-div'>
                        <div className='time-label' >
                            Start time <b style={{ color: '#db2828' }}>*</b>
                        </div>
                        <div className='time-div'>
                            <DatePicker className='timepicker'
                                picker="time"
                                defaultValue={moment(props.startTime, "HH:mm A")}
                                format="h:mm a"
                                use12Hours={true}
                                onChange={(time, timeString) => setStartValue(timeString)}
                                disabledDate={(current) => {
                                    return moment().add(-1, "days") >= current;
                                  }}
                            />
                        </div>
                    </div>
                    <div className='end-time-div'>
                        <div className='time-label'>
                            End time <b style={{ color: '#db2828' }}>*</b>
                        </div>
                        <div className='time-div'>
                            <DatePicker className='timepicker'
                                picker="time"
                                defaultValue={moment(props.endTime, "HH:mm A")}
                                format="h:mm a"
                                use12Hours={true}
                                onChange={(time, timeString) => setEndValue(timeString)}
                                disabledDate={(current) => {
                                    return moment().add(-1, "days") >= current;
                                  }}
                            />
                        </div>
                    </div>
                </div>
                <div className='reason-textarea-div'>
                    <div className='time-label'>
                        Reason for correction <b style={{ color: '#db2828' }}>*</b>
                    </div>
                    <TextArea rows={4} showCount maxLength={150} onChange={(t) => setCorrectionReason(t.target.value)} />
                    {/* <Input type='textarea' showCount maxLength={150}/> */}
                </div>
            </Modal>
        </div>
    )
}
export default CorrectionModal